(()=>{
  const wide=matchMedia('(min-width:1024px)');
  const bindMenus=()=>{
    document.querySelectorAll('.header details[level="top"]').forEach(menu=>{
      if(menu.dataset.fvHover)return;menu.dataset.fvHover='true';let timer;
      menu.querySelector(':scope > summary')?.addEventListener('click',event=>{
        if(!wide.matches||event.detail===0||event.pointerType==='touch'||event.sourceCapabilities?.firesTouchEvents)return;
        const link=event.currentTarget.dataset.link;
        if(link){event.preventDefault();event.stopImmediatePropagation();window.location.assign(link);}
      },true);
      menu.addEventListener('mouseenter',event=>{
        if(!wide.matches||event.sourceCapabilities?.firesTouchEvents)return;
        clearTimeout(timer);
        document.querySelectorAll('.header details[level="top"][open]').forEach(other=>{if(other!==menu)other.open=false;});
        menu.open=true;
      });
      menu.addEventListener('mouseleave',()=>{if(wide.matches){clearTimeout(timer);timer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},180);}});
    });
  };
  const bindFooter=()=>{
    const small=matchMedia('(max-width:767px)');
    const update=()=>document.querySelectorAll('.fc-footer-links').forEach(row=>{row.open=!small.matches;});
    update();small.addEventListener('change',update);
  };
  class FovielPairing extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;
      this.form=this.querySelector('form');
      if(!this.form)return;
      this.button=this.form.querySelector('button[type="submit"]');
      this.status=this.querySelector('[data-fv-pair-status]');
      this.rows=[...this.querySelectorAll('[data-fv-pair-row]')];
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(value/100);
      this.update=()=>{
        const state=this.rows.map(row=>{
          const select=row.querySelector('select'),option=select.selectedOptions[0];
          const included=row.querySelector('[data-fv-include]').checked;
          const price=Number(option?.dataset.price||0);
          const image=row.querySelector('img');
          if(image&&option?.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.textContent.trim();}
          row.querySelector('input[type="hidden"]').disabled=!included;
          return{row,select,option,included,price};
        });
        this.eligible=state.length===3&&state.every(s=>s.included&&s.option&&!s.option.disabled);
        const subtotal=state.reduce((sum,s)=>sum+(s.included?s.price:0),0);
        const saving=this.eligible?Math.round(subtotal*20/100):0;
        // Allocate integer pennies so the displayed item prices add up to the bundle total.
        const discounts=state.map(s=>this.eligible?Math.floor(s.price*20/100):0);
        let remainder=saving-discounts.reduce((sum,n)=>sum+n,0);
        const order=state.map((s,i)=>({i,fraction:(s.price*20)%100})).sort((a,b)=>b.fraction-a.fraction||a.i-b.i);
        for(const{ i }of order){if(remainder<=0)break;discounts[i]++;remainder--;}
        state.forEach((s,i)=>{
          const original=s.row.querySelector('[data-fv-row-original]');
          original.textContent=money(s.price);original.hidden=!this.eligible;
          s.row.querySelector('[data-fv-row-price]').textContent=money(s.price-discounts[i]);
        });
        const original=this.querySelector('[data-fv-total-original]');
        original.textContent=money(subtotal);original.hidden=!this.eligible;
        this.querySelector('[data-fv-total]').textContent=money(subtotal-saving);
        this.querySelector('[data-fv-saving-amount]').textContent=money(saving);
        this.querySelector('[data-fv-savings]').hidden=!this.eligible;
        this.querySelector('[data-fv-requirement]').hidden=this.eligible;
        this.button.disabled=this.busy||!this.eligible;
      };
      this.form.addEventListener('change',()=>{this.status.textContent='';this.update();});
      this.form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(this.added){window.location.assign(this.dataset.discountUrl);return;}
        if(this.busy)return;
        this.update();if(!this.eligible)return;
        this.busy=true;this.button.disabled=true;this.button.textContent=this.button.dataset.adding;
        this.form.setAttribute('aria-busy','true');this.status.textContent='';
        this.bundleKey=this.bundleKey||(crypto.randomUUID?crypto.randomUUID():String(Date.now()));
        const controls=[...this.form.querySelectorAll('select,input[type="checkbox"]')];
        controls.forEach(control=>control.disabled=true);
        const items=this.rows.map(row=>({id:row.querySelector('select').value,quantity:1,properties:{_foviel_bundle:this.bundleKey}}));
        const headers={'Content-Type':'application/json','Accept':'application/json'};
        try{
          const added=await fetch(this.dataset.addUrl,{method:'POST',credentials:'same-origin',headers,body:JSON.stringify({items})});
          const result=await added.json();
          if(!added.ok)throw new Error(result.description||this.status.dataset.error);
          this.added=true;
          const discounted=await fetch(this.dataset.updateUrl,{method:'POST',credentials:'same-origin',headers,body:JSON.stringify({discount:this.dataset.bundleCode})});
          if(!discounted.ok){window.location.assign(this.dataset.discountUrl);return;}
          const cart=await discounted.json();
          if(cart.discount_codes&&!cart.discount_codes.some(code=>code.code.toUpperCase()===this.dataset.bundleCode&&code.applicable)){
            window.location.assign(this.dataset.discountUrl);return;
          }
          window.location.assign(this.dataset.cartUrl);
        }catch(error){
          if(this.added){window.location.assign(this.dataset.discountUrl);return;}
          // A stock change can cause a partial multi-add. Review those items instead of adding twice.
          try{
            const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
            if(response.ok){
              const cart=await response.json();
              if(cart.items?.some(item=>item.properties?._foviel_bundle===this.bundleKey)){
                this.added=true;this.status.textContent=this.status.dataset.partial;
                this.button.textContent=this.status.dataset.review;
                this.busy=false;this.button.disabled=false;this.form.removeAttribute('aria-busy');
                this.button.addEventListener('click',event=>{event.preventDefault();window.location.assign(this.dataset.cartUrl);},{once:true});
                return;
              }
            }
          }catch{}
          this.busy=false;controls.forEach(control=>control.disabled=false);this.form.removeAttribute('aria-busy');
          this.button.textContent=this.button.dataset.label;this.status.textContent=error.message||this.status.dataset.error;this.update();
        }
      });
      const info=this.closest('.product__info');
      this.variantListeners=[];
      info?.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
        if(form===this.form)return;
        const handler=event=>{
          if(this.busy)return;
          const id=event.detail?.variant?.id,select=this.querySelector('[data-main-product] select');
          if(id&&select&&[...select.options].some(option=>option.value===String(id))){select.value=String(id);this.update();}
        };
        form.addEventListener('variant:change',handler);this.variantListeners.push([form,handler]);
      });
      this.update();
      const description=this.parentElement?.querySelector('[data-fc-full-description]'),product=this.closest('.product');
      if(description&&product)product.after(description);
    }
    disconnectedCallback(){this.variantListeners?.forEach(([form,handler])=>form.removeEventListener('variant:change',handler));}
  }

  if(!customElements.get('foviel-pairing'))customElements.define('foviel-pairing',FovielPairing);
  class FovielSpotlight extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;this.cards=[...this.querySelectorAll('[data-fv-spotlight-card]')];this.index=0;
      const key='foviel-style-dismissed-until';
      const dismissed=()=>{try{return Number(sessionStorage.getItem(key)||0)>Date.now();}catch{return false;}};
      const hide=()=>this.cards.forEach(card=>card.hidden=true);
      this.show=()=>{
        hide();
        if(!this.isConnected||!this.cards.length||dismissed())return;
        const blocked=document.hidden||document.querySelector('dialog[open],.drawer[open],cart-drawer[open]');
        if(blocked){this.timer=setTimeout(this.show,10000);return;}
        this.cards[this.index++%this.cards.length].hidden=false;
        this.timer=setTimeout(()=>{hide();this.timer=setTimeout(this.show,45000);},8500);
      };
      this.addEventListener('click',event=>{if(event.target.closest('.fc-popular-close')){clearTimeout(this.timer);hide();try{sessionStorage.setItem(key,String(Date.now()+30*60*1000));}catch{}}});
      this.onVisibility=()=>{clearTimeout(this.timer);hide();if(!document.hidden&&!dismissed())this.timer=setTimeout(this.show,12000);};
      document.addEventListener('visibilitychange',this.onVisibility);
      if(!dismissed())this.timer=setTimeout(this.show,12000);
    }
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.onVisibility);}
  }
  if(!customElements.get('foviel-style-spotlight'))customElements.define('foviel-style-spotlight',FovielSpotlight);
  const stableHeader=()=>{const h=document.querySelector('.header-section');if(h){h.classList.remove('header-hidden','header-nav-scrolled');}document.body.classList.remove('unloading');};
  const init=()=>{bindMenus();bindFooter();stableHeader();};
  window.addEventListener('pageshow',stableHeader);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

